import { useState, useEffect } from 'react';
import { LoadSupplierNetworkUseCase } from '../../application/useCases';
import { SupplierNetwork } from '../../domain/entities';
import { useApp } from '../contexts';

export const useSupplierNetwork = (cnpj?: string) => {
    const { supplierNetwork, setSupplierNetwork, showError } = useApp();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const loadSupplierNetwork = async () => {
            if (!cnpj && supplierNetwork) return;

            try {
                setIsLoading(true);
                const useCase = new LoadSupplierNetworkUseCase();
                const network = await useCase.execute(cnpj);
                
                if (network) {
                    setSupplierNetwork(network);
                } else if (cnpj) {
                    showError('Rede fornecedora não encontrada');
                }
            } catch (error) {
                const message = error instanceof Error ? error.message : 'Error loading supplier network';
                showError(message);
            } finally {
                setIsLoading(false);
            }
        };

        loadSupplierNetwork();
    }, [cnpj]);

    return {
        supplierNetwork,
        isLoading,
    };
};

